import moment from "moment";
export const datesHelper = {
  initialDate,
  adultDate,
  isAdult,
  dateToMoment,
  momentToDate,
  diffenceDays,
  daysBetween
}

/**
 *
 * @returns {moment.Moment}
 */
function initialDate() {
  moment.locale(['es','en','fr'])
  return moment().add(2,'days').valueOf()
}

/**
 * 18 years old
 * @returns {moment.Moment}
 */
function adultDate() {
  moment.locale(['es','en','fr'])
  return moment().subtract(18,'years')
}

/**
 *
 * @param {string} strDate
 * @returns {boolean}
 */
function isAdult(strDate){
  const adult = adultDate()
  const current = moment(strDate)
  return (current.isBefore(adult) || current.isSame(adult))
}

/**
 * Transform regular date to moment object
 * @param {string | number}rawDate Date to convert to moment
 * @returns {moment.Moment} momment object
 */
function dateToMoment(rawDate){
  // No tiene encuenta la hora
  return moment(rawDate)
}

/**
 * Return moment object date to specific format
 * @param {moment.Moment} date Moment object
 * @param {string} format
 * @returns {string}
 */
function momentToDate(date, format = "YYYY-MM-DD") {
  return moment(date).format(format);
}

/**
 * Return the number of days between checkin and checkout
 * @param {moment.Moment} inDate
 * @param {moment.Moment} outDate
 * @returns {number | *}
 */
function diffenceDays(inDate, outDate){
  return outDate.diff(inDate, 'days');
}

/**
 *
 * @param {moment.Moment} inDate
 * @param  {moment.Moment} outDate
 * @returns {moment.Moment} {Array}
 */
function daysBetween(inDate, outDate){
  let result = []

  let _current = inDate.clone().add(1,'day')
  while (_current.isBefore(outDate)){
    result.push(_current)
    _current = _current.clone().add(1,'day')
  }
  return result
}



// WEBPACK FOOTER //
// ./src/_helpers/dates.helper.js